import React, { useContext } from "react"
import { HelpCenterContext } from "./Context/HelpCenterContext"

export const TopSection = () => {
    const { dispatch } = useContext(HelpCenterContext)
    return (
        <div className="d-flex justify-content-between">
            <div data-testid="helpcentertitle" className="k-window-title k-dialog-title title-section">Help Center</div>
            <span role="presentation" onClick={() => dispatch({ type: "TOGGLE_HELPCENTER" })} className="k-button-icon k-icon k-i-x"></span>
        </div>
    )
}